import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import { FeatureGuideGroup } from '../../models/feature-guide.model';

@Component({
  selector: 'app-feature-guide',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonModule, DialogModule, TooltipModule],
  templateUrl: './feature-guide.component.html',
  styleUrl: './feature-guide.component.scss',
})
export class FeatureGuideComponent {
  private readonly cdr = inject(ChangeDetectorRef);

  @Input({ required: true }) title = 'Guide';
  @Input() tooltip = 'Open guide';
  @Input() intro = '';
  @Input() groups: FeatureGuideGroup[] = [];

  visible = false;
  openGroup: string | null = null;

  open(): void {
    this.openGroup = this.groups[0]?.heading ?? null;
    this.visible = true;
    this.cdr.markForCheck();
  }

  close(): void {
    this.visible = false;
    this.cdr.markForCheck();
  }

  toggleGroup(heading: string): void {
    this.openGroup = this.openGroup === heading ? null : heading;
    this.cdr.markForCheck();
  }
}
